<template lang="pug">
.preview-iphone-safari-bottom-search
  v-card.box-shadow.basic100(outlined)
    .d-flex.justify-space-between.align-center.px-2.py-1
      .d-flex.align-end
        .small-font.font-semibold A
        .big-font.font-semibold A
      .d-flex.align-center
        v-icon.mr-1(color="basic700" size="14") $yzi-ios-safari-safe-lock
        .small-font {{ search }}
      v-icon(color="basic700" size="16") mdi-refresh
</template>

<script>
export default {
  name: 'PreviewIphoneSafariSearchBar',
  props: {
    search: {
      type: String,
      required: true
    },
  },
}
</script>

<style scoped>
.box-shadow {
  box-shadow: 0px 4px 7px 2px rgba(0,0,0,0.1);
  -webkit-box-shadow: 0px 4px 7px 2px rgba(0,0,0,0.1);
  -moz-box-shadow: 0px 4px 7px 2px rgba(0,0,0,0.1);
}
.small-font {
  font-size: 12px !important;
}
.big-font {
  font-size: 14px !important;
}
</style>